require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-generator-reason-react-class.json") })
        }
      }, "path---package-generator-reason-react-class");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-generator-reason-react-class!./.cache/json/package-generator-reason-react-class.json
// module id = 859
// module chunks = 231608221292675